import { useTranslation } from 'react-i18next';

function RailsSection() {
  const { t } = useTranslation();
  const capabilities = t('rails.capabilities', { returnObjects: true });
  const tests = t('rails.tests.items', { returnObjects: true });
  const practices = t('rails.practices.items', { returnObjects: true });

  return (
    <section id="rails" className="section rails-section">
      <div className="rails-panel">
        <div className="rails-intro">
          <div className="eyebrow">{t('rails.eyebrow')}</div>
          <h2>{t('rails.title')}</h2>
          <p>{t('rails.description')}</p>

          <div className="rails-highlight">
            <strong>{t('rails.highlight.title')}</strong>
            <span>{t('rails.highlight.text')}</span>
          </div>
        </div>

        <div className="rails-capabilities">
          {capabilities.map((capability) => (
            <article className="rails-capability-card" key={capability.title}>
              <span>{capability.number}</span>
              <h3>{capability.title}</h3>
              <p>{capability.text}</p>
            </article>
          ))}
        </div>

        <div className="rails-quality-grid">
          <div className="rails-quality-card">
            <h3>{t('rails.tests.title')}</h3>
            <p>{t('rails.tests.description')}</p>

            <ul>
              {tests.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="rails-quality-card practices">
            <h3>{t('rails.practices.title')}</h3>
            <p>{t('rails.practices.description')}</p>

            <div className="practice-tags">
              {practices.map((practice) => (
                <span key={practice}>{practice}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RailsSection;
